import type { Size } from "../types";

export const getSizeOfferLabel = (size: Size) =>
  size.showReduced ? size.sizeReductionLabel || "Reduced" : undefined;
